import message from "./message/zh-TW";
import placeholder from "./placeholder/zh-TW";
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc: "Globalpoc",
  hpyj: "深圳市好攀宜佳科技有限公司",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
  yuantong:"pocptt",
  chunsheng:"poclink"
};
let conpanyname = {
    yuantong:"Quanzhou YANTON Electronics Co., Ltd."
}

let beian = {
    yuantong:"Website record number"
}

let icp = {
    yuantong:"Guangdong ICP No. 16086702"
}

let copyright = {
    yuantong:"Copyright © 2021-2022 Quanzhou YANTON Electronics Co., Ltd. Version: v1.7.2"
}
export default {
  language: {
    name: "中文",
    title: "語言",
  },
  about: {
    title: title[NODE_ENV] || "全球對講",
    conpanyname: conpanyname[NODE_ENV] || "深圳市博納德資訊科技有限公司",
    beian: beian[NODE_ENV] || "網站備案號",
    icp: icp[NODE_ENV] || "粵ICP備16086702號",
    copyright: copyright[NODE_ENV] || "版權所有:深圳市博納德資訊科技有限公司 版本號:v2.1.8 copyright ◎ 2021-2022",
  },
  login: {
    tag: {
      agent: "代理商",
      company: "公司",
    },

    placeholder: {
      account: "請輸入登錄帳號",
      password: "請輸入登錄密碼",
    },

    button: {
      login: "登錄",
      remember: "記住帳號？",
    },

    tips: {
      empty: "帳號或密碼不能為空白",
      not_account: "帳號不存在",
      err_password: "密碼錯誤",
      completethepuzzle: "拖動下方滑塊完成拼圖",
      Verificationissuccessful: "驗證成功",
      Verificationerrorpleasetryagain: "驗證錯誤，請重試",
    },
  },
  from: {
    //表单
    icon: "頭像",
    Agent_name: "代理商名稱",
    Account: "登錄帳號",
    Contact_name: "聯繫人姓名",
    mobile: "手機號碼",
    uName: "姓名",
    recharge_contact: "續費聯繫方式",
    Select_Address: "選擇地址",
    Detailed_address: "詳細地址",
    Not_filled_in: "未填寫",
    contact_information: "聯繫方式",
    area: "地區",
    Reset_Password: "重置密碼",
  },
  placeholder: {
    ...placeholder,
  },
  message: {
    //提示
    ...message,
  },
  but: {
    //按钮
    send_out: "發送",
    preserve: "保存",
    confirm: "確認",
    define: "確定",
    next: "下一步",
  },

  agent: {
    Agency_account: "代理商帳戶",
    Contact_information: "聯繫人資訊",
    Please_enter_agentname: "請輸入代理商名稱",
    agentname_required: "（必填：4-20文字、字母、數位）",
    Please_enter_loginAccount: "請輸入登錄帳戶",
    loginAccount_required: "（必填：6-20位字母、數位）",
    Please_enter_loginPassword: "請輸入登錄密碼",
    loginPassword_required: "（必填：6-16字母、數位）",
    Please_enter_contactname: "請輸入聯繫人姓名",
    contactname_required: "（必填：2-20文字、字母、數位）",
    Please_enter_address: "請輸入代理商詳細地址",
    address_optional: "（選填）",
    search_agent: "搜尋代理商",
    recover_integer: "收回服務卡數量必須為整數",
    recover_num: "收回數量必須大於0",
  },

  navigation: {
    personal_center: "個人中心",
    search: "搜尋",
    my_agent: "代理商",
    agent_list: "代理商列表",
    create_agent: "創建代理商",

    my_company: "公司",
    company_list: "公司列表",
    create_company: "創建公司",

    my_group: "群組",
    group_list: "群組列表",
    create_group: "創建群組",

    my_user: "用戶",
    user_list: "用戶列表",
    create_user: "創建用戶",

    news_notice: "消息通知",
    Scanning_code_found: "掃碼創建",

    function_card_sell: "服務卡銷售",
    function_card_record: "服務卡記錄",
    system_annoucement: "系統公告",

    my_bounding: "電子圍欄",
    bounding_list: "圍欄列表",
    create_bounding: "創建圍欄",

    recording_record: "錄音記錄",
    sos_record: "SOS記錄",
    broadcast_record: "廣播記錄",
    Agent_details: "代理商詳細資訊",
    Scancodetocreate: "掃碼創建",
    Createuserinformation: "創建用戶資訊",
    Confirmdetails: "確認詳情",
    EditOrganizationInformation: "編輯公司資訊",
    notificationreminder: "通知提醒",
    selectgroup: "選擇群組",
    edituserinformation: "編輯用戶資訊",
    Userreplacementcard: "用戶補換卡",
    completematerial: "完善資料",
    choosehost: "選擇主持人",
    Selectagrouptolistento: "選擇要監聽的群組",
    Terminalrenewaldetails: "設備續費詳情",
    managementplatform: "管理平台",
    electricfence: "電子圍欄",
    Electronicfencerecords: "電子圍欄記錄",
    Registeraccount: "註冊帳號",
    Boundcompanyusers: "已綁定公司用戶",
    Unboundcompanyusers: "未綁定公司用戶",
    Listofboundcompanyusers: "已綁定公司用戶列表",
    Listofunboundcompanyusers: "未綁定公司用戶列表",
  },

  setup: {
    setup: "設置",
    Change_Password: "重置密碼",
    user_information: "個人資訊",
    Reset_Login_Password: "重置登錄密碼",
    Modify_payment_password: "修改支付密碼",
    about: "關於",
    Problem_feedback: "問題反饋",
    Verify_phone: "驗證手機",
    Set_payment_password: "設置支付密碼",
  },

  org: {
    org_name: "公司名稱",
    createCompany: "新建公司",
    UnitAccount: "公司帳戶",
    createGroups: "同時創建16個群組",
    plGroups: "批量群組名稱後綴加自然數，重複名稱延續自然數",
  },
  consume: "消耗",
  area: "區域",
  logout: "登出",
  VerifyPC: "PC端打開連接",
  // connect: '伺服器連接異常',
  connect: "載入中",
  existing: "現有",
  individual: "個",
  Quantityis: "數量為0，無法收回",
  Withdrawal_quantity: "收回數量不能大於現有數量",
  click_load: "點擊載入更多",
  refresh_successfully: "刷新成功",
  search: "搜尋",
  detail: "詳情",
  edit: "編輯",
  delete: "刪除",
  confirm: "確定",
  cancel: "取消",
  call_back: "收回",
  time: "時間",
  category: "類別",
  title: "標題",
  data: "日期",
  starting_date: "開始日期",
  ending_date: "結束日期",
  starting_time: "開始時段",
  ending_time: "結束時段",
  type: "類型",
  please_select: "請選擇",
  content: "內容",
  notice: "通知",
  tuneto_agent: "調至代理商",
  beingTransferred_agent: "被調代理商",
  thefence: "圍欄",
  member: "成員",
  users: "用戶",
  searchuser: "搜尋用戶",
  group: "群組",
  searchgroup: "搜尋群組",
  company: "公司",
  searchunit: "搜尋公司",
  agent_name: "代理商名稱",
  prefixnickname: "前綴暱稱",
  user_name: "用戶名稱",
  company_name: "所屬公司",
  user_info: "用戶資訊",
  sale: "銷售",
  create_user: "創建用戶",
  start_service: "開通服務",
  recycle_recycled: "收回/被收回",
  delete_users: "刪除用戶",
  deletequantity: "刪除數量",
  purchasement: "購買",
  change_agents: "調換代理商",
  voice: "語音",
  recording: "錄音",
  position: "定位",
  thefence: "圍欄",
  video: "視頻",
  recycle: "收回",
  recycled: "被收回",
  card_type: "服務卡類型",
  card_type1: "服務卡類型",
  select_card_type: "選擇服務卡類型",
  card_number: "服務卡數量",
  ptt_card: "語音卡",
  recording_card: "錄音卡",
  gps_card: "定位卡",
  sos_card: "SOS卡",
  bounding_card: "圍欄卡",
  video_card: "視頻卡",
  duplex_card: "雙工卡",
  vipcard: "Vip卡",
  ptt_card_sale: "語音卡銷售",
  recording_card_sale: "錄音卡銷售",
  gps_card_sale: "定位卡銷售",
  sos_card_sale: "SOS卡銷售",
  bounding_card_sale: "圍欄卡銷售",
  video_card_sale: "視頻卡銷售",
  Duplexcardsales: "雙工卡銷售",
  vipcardsales: "Vip卡銷售",
  pttgpssales: "PTT+GPS銷售",
  usevoicecard: "使用語音卡",
  userecordingcard: "使用錄音卡",
  uselocatorcard: "使用定位卡",
  useSOScard: "使用SOS卡",
  usefencecard: "使用圍欄卡",
  usevideocard: "使用視頻卡",
  Useaduplexcard: "使用雙工卡",
  usepttgps: "使用PTT+GPS",
  usevipcard: "使用VIP卡",
  voiceservicecard: "語音服務卡",
  recordingservicecard: "錄音服務卡",
  locationservicecard: "定位服務卡",
  SOSservicecard: "SOS服務卡",
  fenceservicecard: "圍欄服務卡",
  videoservicecard: "視頻服務卡",
  Dualservicecard: "雙工服務卡",
  vipservicecard: "VIP服務卡",
  voiceservice: "語音服務",
  recordingservice: "錄音服務",
  locationservice: "定位服務",
  SOSservice: "SOS服務",
  fenceservice: "圍欄服務",
  videoservice: "視頻服務",
  duplexservice: "雙工服務",
  recordingcardrecycling: "錄音卡回收",
  LocationCardRecycling: "定位卡回收",
  SOSCardRecycling: "SOS卡回收",
  FenceCardRecycling: "圍欄卡回收",
  videocardrecycling: "視頻卡回收",
  Duplexcardrecycling: "雙工卡回收",
  VoiceFeatureNotification: "語音功能通知",
  Notificationofrecordingfunction: "錄音功能通知",
  Positioningfeaturenotification: "定位功能通知",
  SOSfunctionnotification: "SOS功能通知",
  Fencefeaturenotification: "圍欄功能通知",
  VideoFeatureNotification: "視頻功能通知",
  DuplexFeatureNotification: "雙工功能通知",
  PTTGPSFeatureNotification: "PTT+GPS功能通知",
  automatically: "自動刪除測試用戶通知",
  DeleteExpired: "刪除過期用戶通知",
  remained: "餘額",
  pieces: "張",
  residue: "剩餘",
  recycle_successfully: "收回成功",
  None_record: "暫無記錄",
  this_month: "本月",
  Year: "年",
  moon: "月",
  day: "日",
  weekly1: "週一",
  weekly2: "週二",
  weekly3: "週三",
  weekly4: "週四",
  weekly5: "週五",
  weekly6: "週六",
  weekly7: "週日",
  submit: "提交",
  modify_successfully: "修改成功",
  confirm1: "確認",
  lumpsum: "總額",
  selltoagents: "銷售給代理商",
  nametips:
    "輸入的昵稱只是用戶昵稱的前綴，根據您創建的用戶個數以自然數來做後綴區分。 例如：您輸入的昵稱為",
  nametips2: "您創建的兩個 用戶的昵稱分別為",
  nametips3: "下次再以",
  nametips4: "為前綴的昵稱，用戶名順延為",
  nametips5: "等",
  IMEIscancodetoadd: "IMEI掃碼添加",
  IMEIinputadded: "IMEI輸入添加",
  IMEIinputaddedtocreate: "IMEI輸入添加最多可創建10個用戶",
  Starttherecordingservice: "開啟錄音服務",
  Turnonlocationservices: "開啟定位服務",
  EnableSOSservice: "開啟SOS服務",
  Startfenceservice: "開啟圍欄服務",
  Turnondualservice: "開啟雙工服務",
  Turnonthevideoservice: "開啟視頻服務",
  EnablePTTservice: "開啟PTT服務",
  EnableVIPservice: "開啟VIP服務",
  PTTGPSService:"語音+定位服務",
  Usercomments: "用戶備註",
  Agentnote: "代理商備註",
  total: "合計",
  settlement: "結算",
  hint: "提示",
  Areyousuretoremove: "確認移除嗎？",
  Areyousuretoclearall: "確認全部清空嗎？",
  cocreated: "共同創建",
  accountssubtotal: "個帳戶，小計",
  Scancodeentryarea: "掃碼登錄區",
  empty: "清空",
  none: "無",
  Second: "秒",
  Salesvolume: "銷售數量",
  Purchasequantity: "購買數量",
  returnquantity: "退回數量",
  Recoveredquantity: "收回數量",
  returnquantity2: "返回數量",
  setasdefaultgroup: "設為預設群組",
  newgroup: "新建群組",
  groupname: "群組名稱",
  selected: "已選",
  groups: "個群組",
  allgroups: "全部群組",
  Groupduration: "群組時長",
  calltime: "通話時長",
  groupmembers: "群組成員",
  Modifygroupname: "修改群組名稱",
  priority: "優先層級",
  remove: "移除",
  addmembers: "添加成員",
  levelone: "一級",
  Secondary: "二級",
  Levelthree: "三級",
  Levelfour: "四級",
  Fifthgrade: "五級",
  OKtoadd: "確定添加",
  reenter: "重新輸入",
  Setdigitservicecardpassword: "設置6位數服務卡密碼",
  Enteragaintoconfirm: "再次輸入確認",
  Enterthedigitservicecardpassword: "輸入6位服務卡密碼",
  consumptioncard: "消費定位卡",
  ConsumeSOScard: "消費SOS卡",
  Consumefencecard: "消費圍欄卡",
  Consumptionrecordingcard: "消費錄音卡",
  Consumeduplexcard: "消費雙工卡",
  Consumptionvideocard: "消費視頻卡",
  account: "帳號",
  unfilled: "未填寫",
  contactnumber: "聯繫電話",
  emailaddress: "郵件地址",
  mailingaddress: "通訊地址",
  Belonginggroup: "所屬群組",
  Nickname: "昵稱",
  suspendaccount: "帳號",
  unitdispatcher: "公司調度員",
  dispatcher: "調度員",
  basestationpositioning: "基站定位",
  GPSlocation: "GPS定位",
  positioninginterval: "定位間隔",
  videocall: "視頻呼叫",
  strongpullvideo: "強拉視頻",
  videoreturn: "視頻回傳",
  Numberchangeperiod: "換號期限",
  UsersNickname: "用戶暱稱",
  volumeactivation: "批量啟動",
  batchselection: "批量選擇",
  searchhistory: "搜尋歷史記錄",
  returnnotice: "返回通知",
  Notificationofbeingwithdrawn: "被收回通知",
  takebacknotice: "收回通知",
  bouncenotification: "退回通知",
  Notificationofbeingreturned: "被退回通知",
  Createusernotification: "創建用戶通知",
  purchasenotice: "購買通知",
  salereminder: "銷售提醒",
  today: "今天",
  yesterday: "昨天",
  thedaybeforeyesterday: "前天",
  OriginalIMEI: "原IMEI",
  NewIMEI: "新IMEI",
  replace: "更換",
  verificationcode: "驗證碼",
  resendverificationcode: "重發驗證碼",
  back: "後",
  host: "主持人",
  listeninggroup: "監聽群組",
  Addlisteninggroup: "添加監聽群組",
  Nodata: "暫無數據",
  Corenewal: "共續費",
  Accountssubtotal: "個帳戶，小計",
  Confirmrenewal: "確認續費",
  add_groupname_tips: "批量群組名稱後綴加自然數，重複名稱延續自然數",
  Dataloadingcomplete: "數據載入完成",
  Usercreatedgroups: "用戶自建組",
  Lord: "群主",
  chooseagroupleader: "選擇群主",
  alluser: "全部用戶",
  SOSalarmsintemporarygroupsarenotrecorded: "臨時群組中的SOS警告不做記錄",
  username: "用戶名稱",
  startingtime: "發起時間",
  Processor: "處理人",
  processtime: "處理時間",
  Unprocessed: "未處理",
  Processed: "已處理",
  deleted: "已刪除",
  name: "名稱",
  address: "地址",
  Warmreminder: "溫馨提示：數據來源第三方，會存在誤差，僅供參考",
  SOSlocation: "SOS位置",
  permanent: "永久",
  Latitudeandlongitude: "經緯度",
  Reportingtime: "上報時間",
  Positioningtime: "定位時間",
  op1: "開啟",
  op2: "關閉",
  groupban: "群組禁言",
  setptt: "設定語音服務期",
  Determinethemodification: "確認修改",
  Onemonth: "一個月",
  Threemonths: "三個月",
  Halfayear: "半年",
  Expiredate: "到期時間",
  year1: "一年",
  year2: "二年",
  year3: "三年",
  Sun: "日",
  Mon: "一",
  Tue: "二",
  Wed: "三",
  Thu: "四",
  Fri: "五",
  Sat: "六",
  Membermanagement: "成員管理",
  Validpermanently: "永久有效",
  Enteralarm: "進入警告",
  Leavealarm: "離開報警",
  repeat: "重複",
  Updatefence: "更新圍欄",
  Triggermode: "觸發方式",
  Validperiod: "有效時段",
  start: "開始",
  end: "結束",
  Validdate: "有效日期",
  fencekeeper: "圍欄管理員",
  Membermanagement: "成員管理",
  fencename: "圍欄名稱",
  Editfence: "編輯圍欄",
  Setupafencemanager: "設置圍欄管理員",
  Fencedetails: "圍欄詳情",
  Currentoutofboundsrecord: "當前越界記錄",
  Historicalcrossborderrecords: "歷史越界記錄",
  Allfences: "全部圍欄",
  Triggertime: "觸發時間",
  Releasetime: "解除時間",
  NoExit: "禁出",
  NoEntry: "禁入",
  Recordinglist: "錄音列表",
  temporarygroup: "臨時群組",
  Voicelicensetype: "語音卡類型",
  Voicelicensetime: "語音卡時間",
  UTCtimeTips: "到期時間為UTC時間",
  Determinethereplacement: "確定更換",
  Regionalreplacement: "區域更換",
  Recoverypassword: "恢復密碼",
  usertype: "用戶類型",
  Singlefunctioncarduser: "單功能卡用戶",
  vipcarduser: "VIP卡用戶",
  PTTGPS: "PTT+GPS",
  PTTGPSuser: "PTT+GPS用戶",
  display: "成員顯示",
  Service_card_display: "服務卡顯示",
  RequiredvoiceserviceorVIPservice: "必選語音服務或VIP服務",
  is_card: {
    ptt: "語音",
    recording: "錄音",
    gps: "定位",
    sos: "SOS",
    bounding: "圍欄",
    duplex: "雙工",
    vip: "Vip",
  },
  Dispatcherrole: "調度員角色",
  ServiceTimeDisplay:'顯示服務資訊',
  show: "顯示",
  point: "單呼功能",
  IMEIchange: "IMEI修改",
  Register: "註冊",
  Bindingdevice: "綁定裝置",
  Notactivated: "未啟用",
  Platformcreation: "平台創建",
  Userregistration: "用戶註冊",
  Binding: "綁定",
  Notenabled: "未開啟",
  Unbinding: "解綁",
  userPatrol: {
    PatrolCard: "巡更卡",
    Patrol: "巡更",
    DisplayPatrolCard: "顯示巡更卡",
    GuardCardRecycling: "巡更卡回收",
    patrolService: "巡更服務",
    ConsumePatrolCards: "消耗巡更卡",
    StartPatrolService: "開啟巡更服務",
    YourPatrolCardIsInsufficientPleaseRecharge: "您的巡更卡不足，請先儲值！",
    UsingPatrolCards: "使用巡更卡",
    PatrolCardBalanceInsufficient: "巡更卡餘額不足",
    PatrolServiceCard: "巡更服務卡",
    PatrolCardSales: "巡更卡銷售",
    PatrolFunctionNotification: "巡更功能通知",
    PatrolManagement: "巡更管理",
    PatrolPlan: "巡更計劃",
    ExecuteTheTask: "執行任務",
    PatrolReport: "巡更報表",
    SearchPlan: "搜尋計劃",
    Suspended: "已暫停",
    Enabled: "已啟用",
    NewPlans: "新增計劃",
    TerminalReminderSettings: "終端提醒設定",
    ReminderRules: "提醒規則",
    ReminderTime: "提醒時間",
    NumberOfReminders: "提醒次數",
    minute: "分鐘",
    note1:
      "註:若設定巡更開始提醒時間為30分鐘，提醒用戶2次。那麼參與巡更的使用者就會在巡更開始前30分鐘收到第1訊息提醒，在開始前15分鐘收到第2訊息提醒，以此類推提醒次數。",
    PleaseEnterTheReminderTime: "請輸入提醒時間",
    PleaseEnterTheNumberOfReminders: "請輸入提醒次數",
    PleaseEnterANumberGreaterThanOrEqualTo20: "請輸入大於等於20的數值",
    PleaseEnterANumberLessThanOrEqualTo5: "請輸入小於等於5的數值",
    OperationSuccessful: "操作成功",
    NewPatrolPlan: "新增巡更計劃",
    PleaseEnterThePlanName: "請輸入計劃名稱",
    UsersWhoNeedPatrols: "需要巡更的用戶",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols:
      "只有開通巡更服務的一般使用者才能執行巡更",
    EffectiveDateOfThePlan: "計劃生效時間",
    PlannedStatus: "計劃狀態",
    Week: "星期",
    DailyPatrolTime: "每日巡更時間",
    TaskGenerationTime: "任務生成時間",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:
      "每天自動產生隔日計畫執行任務的時間",
    patrolPoint: "巡更點",
    save: "儲存",
    TheProjectNameAlreadyExists: "計劃名稱已存在",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "名稱由1~50位中文，數字，字母，特殊符號組成",
    PleaseSelectTheUserWhoNeedsToBePatrolled: "請選擇需要巡更的用戶",
    PleaseSelectTheEffectiveDateOfThePlan: "請選擇計劃生效時間",
    PleaseSelectDailyPatrolTime: "請選擇每日巡更時間",
    TheEndTimeMustBeGreaterThanTheStartTime: "結束時間大於開始時間",
    PleaseSelectTheTaskGenerationTimeForTheNextDay: "請選擇隔日生成任務時間",
    PleaseAddPatrolPoints: "請加入巡更點",
    PatrolUsers: "巡更用戶",
    AddUser: "新增用戶",
    ConfirmAdd: "確定添加",
    PleaseSelectTheUserYouWishToAdd: "請選擇需要新增的用戶",
    UserAddedSuccessfully: "用戶添加成功",
    AddTo: "添加",
    PatrolPointNames: "巡更點名稱",
    PleaseEnterThePatrolPointName: "請輸入巡更點名稱",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "(必填：名稱由1~50位中文，數字，字母，特殊符號組成)",
    NFCNumber: "NFC號碼",
    PleaseEnterYourNFCNumber: "請輸入NFC號碼",
    Required150Characters: "(必填：1-50個字元組成)",
    ThePatrolPointNameAlreadyExists: "巡更點名稱已存在",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "名稱由1-50位中文，數字，字母，特殊符號組成",
    Remark: "備註",
    NoteWithin100Characters: "備註：100字以內",
    CreationSuccessful: "創建成功",
    EditorsPatrolPoint: "編輯巡更點",
    save1: "儲存",
    ModificationSuccessful: "修改成功",
    delete: "删除",
    Remove: "移除",
    AreYouUreYouWantToDeleteThisPatrolPoint: "確定要刪除此巡更點嗎？",
    DeletionSuccessful: "刪除成功",
    EditorsPatrolPlan: "編輯巡更計劃",
    PatrolPlanDetails: "巡更計劃詳情",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled:
      "確認要暫停計劃嗎？暫停後將取消今日待巡任務",
    OperationSuccessful1: "操作成功",
    PleaseSelectTime: "請選擇時間",
    FullPlan: "全部計劃",
    AllUsers: "全部用戶",
    ProjectName: "計劃名稱",
    PatrolUsers1: "巡更用戶",
    PatrolTime: "巡更時間",
    NotStarted: "未開始",
    inProgress: "進行中",
    Completed: "已完成",
    MissedInspection: "漏巡",
    PleaseEnterYourUsername: "請輸入使用者名稱",
    ExecutionDetails: "執行任務詳情",
    PatrolPointNames1: "巡更點名稱",
    PatrolYype: "巡更類型",
    ExecutionResult: "執行結果",
    position: "定位",
    NFC: "NFC",
    Bluetooth: "藍牙",
    PleaseSelectPatrolUser: "請選擇巡更用戶",
    DailyStatistics: "按天統計",
    WeeklyStatistics: "按週統計",
    MonthlyStatistics: "按月統計",
    time: "時間",
    NumberOfPlannedExecutions: "計劃執行次數",
    ActualNumberOfExecutions: "實際執行次數",
    NumberOfMissedInspections: "漏巡次數",
    CompletionRate: "完成率",
    PleaseEnterYourUsername: "請輸入使用者名稱",
    Existing: "已存在",
    NewPatrolPoints: "新增巡更點",
  },
  minute: "分鐘",
  Reclaim: "收回",
  TestUser: "測試用戶",
  test_t: "測試",
  Formal: "正式",
  Testuserscannotactivatefeatureservices: "測試用戶無法開通功能服務！",
};
